/* eslint-disable no-underscore-dangle */

'use-strict';

import { IScope, ITimeoutService, ILocationService } from 'angular';
import objectHash from 'object-hash';
import { SimpleChanges } from '@angular/core';

import { CommentAPIService } from '../../shared/api/comment-api.service';
import { SalesAPIService } from '../../shared/api/sales-api.service';
import { FileService } from '../../shared/storage/file.service';
import { InterfaceService } from '../../shared/interface/interface.service';
import { ToastService, ToastType } from '../../ui-components/toast/toast.service';
import { VehicleLockRequest } from '../../src/app/@shared-types/vehicle/lock';
import { UsersService } from '../../shared/users/users.service';
import { AutoboardVehicle } from '../../src/app/@shared-types/vehicle';
import { Comment, ECommentContext, ECommentType } from '../../src/app/@shared-types/misc/comment';
import { EFileSection, File } from '../../src/app/@shared-types/misc/file';
import LogService from '../../src/app/shared/services/log';
import { NumberConversionService } from '../../shared/converter/number-converter.service';
import { SocketService } from '../../shared/connections/web-socket.service';
import { OpportunityModel } from '../../src/app/shared/models/opportunity/opportunity';
import { EnrichedOpportunity } from '../../src/app/@shared-types/opportunites';
import { PermissionsService } from '../authorization/permissions.service';
import { UserRole } from '../../src/app/@types/user';
import { EFuelType } from '../../src/app/@shared-types/vehicle/enums';
import { Vehicle } from '../../src/app/shared/models/vehicle/vehicle';
import { DeepPartial } from '../../src/app/@shared-types';
import { VehicleExportError } from '../../src/app/@shared-types/api/export-crud';
import TranslationService from '../../src/app/shared/models/translations/service';
import { EExportAPI } from '../../src/app/@shared-types/api';
import { VehicleStatistics } from '../../src/app/@shared-types/vehicle/statistics';

export interface VehicleDetailPrices {
  main?: string,
  mainDescription?: string,
  secondary?: string,
  secondaryDescription?: string,
}

type VehicleWebSocketUpdate = {
  data: DeepPartial<AutoboardVehicle>,
  vehicleId: string,
};

/* @ngInject */
export default class VehicleDetailController {
  private lockPreloader = false;

  private ready = false;

  private vehicleId!: string;

  private vehicle: AutoboardVehicle | null = null;

  private statistics: VehicleStatistics | null = null;

  private vehicleModel: Vehicle;

  private exit!: () => void;

  private dummyVehicle!: boolean;

  private active = false;

  private $rootScope: IScope;

  private $scope: IScope;

  private salesApiService: SalesAPIService;

  private commentApiService: CommentAPIService;

  private fileService: FileService;

  private interfaceService: InterfaceService;

  private numberConversionService: NumberConversionService;

  private logService: LogService;

  private toastService: ToastService;

  private usersService: UsersService;

  private socketService: SocketService;

  private opportunityModel: OpportunityModel;

  private $location: ILocationService;

  private permissionsService: PermissionsService;

  private translationService: TranslationService;

  private overlay: {
    visiblity: boolean,
    action: string,
    title: string,
    customerId?: string,
  } = {
    visiblity: false,
    action: '',
    title: '',
  };

  public generalComments: Comment[] | null = [];

  public fundingComments: Comment[] | null = [];

  public files: File[] | null = null;

  private prices: VehicleDetailPrices = {};

  private lockOtherClient = false;

  private vehicleImages: string[] = [];

  /** When changed, the gallery will re-initialize */
  public galleryHash = '';

  /** Used to redraw one time bindings. Will be set false when updates should be processed. */
  public refresher = true;

  private $timeout: ITimeoutService;

  public warnings: VehicleExportError[] = [];

  private delayedBindingUpdate = false;

  private opportunities: EnrichedOpportunity[] = [];

  constructor(
    $rootScope: IScope,
    $scope: IScope,
    salesApiService: SalesAPIService,
    commentApiService: CommentAPIService,
    fileService: FileService,
    interfaceService: InterfaceService,
    numberConversionService: NumberConversionService,
    toastService: ToastService,
    usersService: UsersService,
    logService: LogService,
    $timeout: ITimeoutService,
    socketService: SocketService,
    opportunityModel: OpportunityModel,
    $location: ILocationService,
    permissionsService: PermissionsService,
    vehicle: Vehicle,
    translationService: TranslationService,
  ) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.salesApiService = salesApiService;
    this.commentApiService = commentApiService;
    this.fileService = fileService;
    this.interfaceService = interfaceService;
    this.numberConversionService = numberConversionService;
    this.toastService = toastService;
    this.usersService = usersService;
    this.logService = logService;
    this.$timeout = $timeout;
    this.socketService = socketService;
    this.opportunityModel = opportunityModel;
    this.$location = $location;
    this.permissionsService = permissionsService;
    this.vehicleModel = vehicle;
    this.translationService = translationService;

    ($scope as any).currentUser = ($rootScope as any).globals.currentUser;

    this.refresher = true;

    this.socketService.on('sales_updateVehicleData', (payload: string) => {
      const parsed: VehicleWebSocketUpdate = JSON.parse(payload);
      if (parsed.vehicleId !== this.vehicleId) return;

      if (!this.delayedBindingUpdate) {
        this.updateOneTimeBindings();
      }
      // let vehicleToUpdate = this.tableData.find((v) => v._id.toString() === parsed.vehicleId);
      // if (!vehicleToUpdate) return;

      // const merged = this.objectService
      //   .mergeObjects<AutoboardVehicle>(vehicleToUpdate, parsed.data as AutoboardVehicle);
      // vehicleToUpdate = merged;

      // // TODO:
      // // if (this.detailVehicle && String(this.detailVehicle._id) === parsed.vehicleId) {
      // //   this.detailHash = objectHash(merged);
      // // }
    });
  }

  $onInit(): void {}

  $doCheck(): void {
    if (this.vehicleId && !this.active) {
      this.active = true;
      this.init();
    }
  }

  /** One time bindings are updated, when the provided hash
   * value changes. The global `refresher` will be set false
   * for a very short time and then be set to true again.
   *
   * Prevent user editing a vehicle from seeing updates.
   * */
  $onChanges(changesObj: SimpleChanges): void {
    if (changesObj.hash && this.overlay.action) {
      this.delayedBindingUpdate = true;
    } else if (changesObj.hash && !this.overlay.action) {
      this.updateOneTimeBindings();
    }
  }

  public init = async (): Promise<void> => {
    this.$rootScope.$on('updateComments', () => {
      this.getDetailedCarData();
    });

    (this.$rootScope as any).bodyOverFlowHide = true;
    this.updateOneTimeBindings();

    setTimeout(() => {
      this.ready = true;
      this.interfaceService.applyScope(this.$scope);
    }, 10);
  };

  /** Empty values might be saved as `null`, these should not be shown */
  public hasValues = (values?: { [key: string]: number | null | undefined }): boolean => Object
    .values(values || {})
    .some((v) => v !== null && v !== undefined);

  public getVehicle = async (): Promise<void> => {
    if (this.dummyVehicle) {
      this.vehicle = await this.vehicleModel.getDummyVehicle(this.vehicleId);
    } else {
      this.vehicle = await this.vehicleModel.get(this.vehicleId);
    }
  };

  public getStatistics = async (): Promise<void> => {
    if (!this.permissionsService.isPermitted([UserRole.SELLER, UserRole.SELLER_PLUS])) return;

    const stats = await this.vehicleModel.getStatistics(this.vehicleId);
    this.statistics = stats || null;
  };

  public updateOneTimeBindings = async (): Promise<void> => {
    this.refresher = false;
    this.vehicle = null;

    await this.getVehicle();
    await this.getStatistics();
    this.getDetailedCarData();
    this.initWarnings();

    this.$timeout(() => {
      this.refresher = true;
      this.interfaceService.applyScope(this.$scope);
    });
  };

  /**
   * When directive initializes some additonal data must be retrieved for display.
   */
  async getDetailedCarData(): Promise<void> {
    if (!this.vehicle) return;

    this.lockOtherClient = false;
    this.vehicleImages = this.vehicle.vehicleData.images || [];

    if (
      this.vehicle.vehicleData.lock
      && this.vehicle.vehicleData.lock.user !== this.usersService.currentUserId()
    ) {
      this.lockOtherClient = true;
    } else if (this.vehicle.vehicleData.lock) {
      this.toolbarAction(this.vehicle.vehicleData.lock.reason, false, '');
    } else if (this.$location.search().action) {
      const { customerId, action } = this.$location.search();

      this.toolbarAction(action, true, '', customerId);
      this.$location.search('action', null);
      this.$location.search('customerId', null);
    } else {
      this.overlay.visiblity = false;
      this.overlay.action = '';
    }

    this.galleryHash = '';
    this.$timeout(() => {
      if (!this.vehicle) return;
      this.galleryHash = objectHash(this.vehicle.vehicleData.images || {});
    });

    this.fileService.getByContext(EFileSection.VEHICLE, String(this.vehicle._id))
      .then((files) => {
        this.files = files;
        return this.commentApiService.getByContext(
          ECommentContext.VEHICLE,
          this.vehicleId,
        );
      })
      .then((comments) => {
        this.generalComments = comments.filter((c) => c.type !== ECommentType.FUNDING);
        this.fundingComments = comments.filter((c) => c.type === ECommentType.FUNDING);
      })
      .catch((e) => {
        this.toastService.toast(ToastType.ERROR, 'Fehler beim Laden der Detailansicht');
        this.logService.error(e);
      });

    if (this.permissionsService.isPermitted([UserRole.SELLER, UserRole.SELLER_PLUS])) {
      this.opportunities = await this.opportunityModel.getForVehicle(String(this.vehicle._id));
    }

    const vatRate = this.vehicle.vehicleData.price.vatRate || 0.19;
    const prices = this.vehicle.vehicleData.price;

    if (prices.retailPrices.offer) {
      this.prices.main = this.numberConversionService
        .calculatePriceWithTax(prices.retailPrices.offer, vatRate);
      this.prices.mainDescription = `Aktuelle UPE (inkl. ${vatRate * 100}% MwSt.)`;
    } else if (prices.retailPrices.invoice) {
      this.prices.main = this.numberConversionService
        .calculatePriceWithTax(prices.retailPrices.invoice, vatRate);
      this.prices.mainDescription = `UPE Eingangsrechnung (inkl. ${vatRate * 100}% MwSt.)`;
    } else if (prices.retailPrices.manufacturer) {
      this.prices.main = this.numberConversionService
        .calculatePriceWithTax(prices.retailPrices.manufacturer, vatRate);
      this.prices.mainDescription = `UPE Hersteller (inkl. ${vatRate * 100}% MwSt.)`;
    }

    if (prices.campaignPrice) {
      this.prices.secondary = String(prices.campaignPrice);
      this.prices.secondaryDescription = prices.includesVat ? `Verkaufspreis (inkl. ${vatRate * 100}% MwSt.)` : 'Verkaufspreis (Differenzbesteuert nach §25a UStG)';
    } else if (prices.onlinePrice) {
      this.prices.secondary = String(prices.onlinePrice);
      this.prices.secondaryDescription = prices.includesVat ? `Preis Onlinebörsen (inkl. ${vatRate * 100}% MwSt.)` : 'Preis Onlinebörsen (Differenzbesteuert nach §25a UStG)';
    }

    this.interfaceService.applyScope(this.$scope);
  }

  /**
   * User selects action from toolbar.
   *
   * @param {SALES_TABLE_ACTIONS} action which form the user requested
   * @param {Boolean} lock if car needs to be locked before editing
   */
  async toolbarAction(
    action: string,
    lock: boolean,
    title: string,
    customerId?: string,
  ): Promise<void> {
    this.overlay.visiblity = true;
    this.overlay.action = action;
    this.overlay.title = title;
    this.overlay.customerId = customerId;

    this.delayedBindingUpdate = true;

    if (lock) {
      this.lockPreloader = true;
      const lockRequest: VehicleLockRequest = {
        reason: action,
        user: this.usersService.currentUserId(),
        vehicleId: this.vehicleId,
        dummyVehicle: this.dummyVehicle,
      };

      this.salesApiService.postVehicleLock(lockRequest)
        .then(() => {
          this.lockPreloader = false;
          this.interfaceService.applyScope(this.$scope);
        })
        .catch((e) => {
          this.overlay.visiblity = false;
          this.overlay.action = '';
          delete this.overlay.customerId;
          this.toastService.toast(ToastType.ERROR, 'Fahrzeug kann nicht bearbeitet werden.');
          this.logService.error(e);
        });
    }
  }

  initWarnings(): void {
    if (!this.vehicle) return;

    this.warnings = this.vehicle.apiData?.exportErrors || [];
    this.warnings.forEach((w) => {
      w.apiIdentifier = this.translationService
        .translateExportAPI(w.apiIdentifier) as unknown as EExportAPI;
    });
  }

  public isPHEV = (): boolean => {
    if (!this.vehicle) return false;

    switch (this.vehicle.modelData?.engine.fuel.type) {
      case EFuelType.HybridDieselPlugin:
      case EFuelType.HybridPetrolPlugin:
        return true;

      default: return false;
    }
  };

  /** BEV and PHEV vehicles have a traction battery */
  public isElectrified = (): boolean => {
    if (!this.vehicle) return false;

    return this.isPHEV() || this.vehicle.modelData?.engine.fuel.type === EFuelType.Electricity;
  };

  public getStaticUrl = (staticId: string): string => this.fileService.getStaticUrl(staticId);

  public getFuelUnit = (): string => {
    if (!this.vehicle) return '';

    switch (this.vehicle.modelData?.engine.fuel.type) {
      case EFuelType.CNG:
      case EFuelType.Hydrogen:
        return 'kg/100 km';

      default: return 'l/100 km';
    }
  };

  /**
   * When a form directive wants to exit, it calls this method.
   * If successfull, load the expanded view again to update everything.
   */
  async finishFormTransmission(
    removeLock: boolean,
    redirect: string,
  ): Promise<void> {
    if (!this.vehicle) return;

    this.overlay.visiblity = false;
    this.overlay.action = '';
    delete this.overlay.customerId;

    if (removeLock && !this.dummyVehicle) { // form submission was aborted
      await this.salesApiService.deleteVehicleLock(String(this.vehicle._id));
    }

    /** If user comes from eg. an opportunity directly
     * to an action / form, we will redirect to the origin
     * if provided as a query param. */
    if (this.$location.search().redirect || redirect) {
      const r = redirect || this.$location.search().redirect;
      this.$location.search('id', null);
      this.$location.search('redirect', null);
      this.interfaceService.navigateToUrl(r);
      return;
    }

    if (this.delayedBindingUpdate) {
      this.updateOneTimeBindings();
      this.delayedBindingUpdate = false;
    }

    this.getDetailedCarData();
    /** Forces refresher wrapper to update one time bindings of vehicle detail component
     * to see the changes made by the user. */
    this.$rootScope.$broadcast('refresherUpdate');
  }

  close(): void {
    this.ready = false;

    setTimeout(() => {
      this.exit();
      this.interfaceService.applyScope(this.$scope);
    }, 250);
  }

  /** TODO: Create dedicated component for this */
  public getExternalCompanyName = (tenantId: string): string => {
    const companies = this.usersService.getExternalCompanies();
    const company = companies.find((c) => c.id === tenantId);
    return company?.name || '(Händler ohne Namen)';
  };
}
